import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// IHG
import ContactList from "../Pages/Dashboard/contact-list";
import BotBuilder from "../Pages/Dashboard/botbuilder";
import EditBot from "../Pages/Dashboard/botbuilder/EditBot";

// Import Calender
import Calender from "../Pages/Calender";

//Modules
import ContactLists from "../Pages/ContactLists";
import ContactListDetails from "../Pages/ContactLists/details.js";
import Campaigns from "../Pages/Campaigns";
import CampaignCreate from "../Pages/Campaigns/create.js";
import CampaignDetails from "../Pages/Campaigns/details.js";

import LandingTemplates from "../Pages/LandingTemplates/index.js";
import EmailTemplates from "../Pages/EmailTemplates/index.js";
import Automation from "../Pages/Automation";
import Workflows from "../Pages/Automation/Workflows";
import WorkflowBuilder from "../Pages/Automation/Workflows/builder";
import Executions from "../Pages/Automation/Executions";
import Events from "../Pages/Events";

// Import E-mail
import Inbox from "../Pages/E-mail/Inbox";
import ReadEmail from "../Pages/E-mail/ReadEmail";
import EmailCompose from "../Pages/E-mail/EmailCompose";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";

// Import Authentication Inner Pages
import Login1 from "../Pages/AuthenticationPages/Login";
import Register1 from "../Pages/AuthenticationPages/Register";
import RecoverPassword from "../Pages/AuthenticationPages/RecoverPassword";
import LockScreen from "../Pages/AuthenticationPages/LockScreen";

// Import Utility Pages
import StarterPage from "../Pages/Utility/Starter-Page";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import TimeLine from "../Pages/Utility/TimeLine-Page";
import FAQs from "../Pages/Utility/FAQs-Page";
import Pricing from "../Pages/Utility/Pricing-Page";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// Import UIElement Pages
import UiAlerts from "../Pages/UiElements/UiAlerts";
import UiBadge from "../Pages/UiElements/UiBadge";
import UiBreadcrumb from "../Pages/UiElements/UiBreadcrumb";
import UiButtons from "../Pages/UiElements/UiButtons";
import UiCards from "../Pages/UiElements/UiCards";
import UiCarousel from "../Pages/UiElements/UiCarousel";
import UiDropdown from "../Pages/UiElements/UiDropdowns";
import UiGrid from "../Pages/UiElements/UiGrid";
import UiImages from "../Pages/UiElements/UiImages";
import UiLightbox from "../Pages/UiElements/UiLightbox";
import UiModals from "../Pages/UiElements/UiModals";
import UiOffcanvas from "../Pages/UiElements/UiOffcanvas";
import UiRangeSlider from "../Pages/UiElements/UiRangeSlider";
import UiSessionTimeout from "../Pages/UiElements/UiSessionTimeout";
import UiPagination from "../Pages/UiElements/UiPagination";
import UiProgressBars from "../Pages/UiElements/UiProgressBars";
import UiPlaceholders from "../Pages/UiElements/UiPlaceholders";
import UiTabs from "../Pages/UiElements/UiTabs&Accordions";
import UiTypography from "../Pages/UiElements/UiTypography";
import UiToasts from "../Pages/UiElements/UiToasts";
import UiVideo from "../Pages/UiElements/UiVideo";
import UiPopovers from "../Pages/UiElements/UiPopovers&Tooltips";
import UiRating from "../Pages/UiElements/UiRating";

// Import Forms
import FormEditors from "../Pages/Forms/FormEditors";
import FormUpload from "../Pages/Forms/FormUpload";
import FormXeditable from "../Pages/Forms/FormXeditable";
import FormMask from "../Pages/Forms/FormMask";
import FormElements from "../Pages/Forms/FormElements";
import FormAdvanced from "../Pages/Forms/FormAdvanced";
import FormValidations from "../Pages/Forms/FormValidations";
import FormWizard from "../Pages/Forms/FormWizard";

// Import Tables
import BasicTable from "../Pages/Tables/BasicTable.js";
import ListJs from "../Pages/Tables/ListTables/ListTables";
import DataTable from "../Pages/Tables/DataTables/DataTables";

// Import Charts
import ApexCharts from "../Pages/Charts/ApexCharts";
import ChartJs from "../Pages/Charts/ChartjsCharts";
import Sparklinechart from "../Pages/Charts/SparklineCharts";
import FloatChart from "../Pages/Charts/FloatCharts";
import JknobCharts from "../Pages/Charts/JqueryKnobCharts";

// Import Icon Pages
import IconMaterialdesign from "../Pages/Icons/IconMaterialdesign";
import IconFontawesome from "../Pages/Icons/IconFontAwesome";
import IconDripicons from "../Pages/Icons/IconDrip";
import IconBoxicons from "../Pages/Icons/IconBoxicons";

// Import Map Pages
import VectorMaps from "../Pages/Maps/VectorMap";
import GoogleMap from "../Pages/Maps/GoogleMap";
import Leads from "../Pages/Leads/index.js";
import LeadsDetails from "../Pages/Leads/details.js";
import CreateLead from "../Pages/Leads/create.js";
import EmailValidation from "../Pages/EmailValidation/index.js";
import EmailProviders from "../Pages/EmailProviders/index.js";
import CalendarProviders from "../Pages/CalendarProviders/index.js";
import NewAITemplate from "../Pages/EmailTemplates/NewAITemplate.js";
import NewBuilder from "../Pages/EmailTemplates/NewBuilder.js";
import NewTemplate from "../Pages/EmailTemplates/NewTemplate.js";
import EmailComponent from '../Pages/NewEmail/index.js'
import DetailsEmailTemplate from "../Pages/EmailTemplates/details.js";
import CorporateIdentity from "../Pages/CorporateIdentity/index.js";
import WhatsAppTemplates from "../Pages/WhatsAppTemplates/index.js";
import WhatsAppProviders from "../Pages/WhatsAppProviders/index.js";
import Conversations from "../Pages/Conversations/index.js";
import EditEmailTemplate from "../Pages/EmailTemplates/edit.js";
import PasswordRecovery from "../Pages/PassRecovery/index.js";
import ResetPassword from "../Pages/PassRecovery/ResetPassword.js";
import OnboardingPage from "../Pages/Onboarding/index.js";
import Pages from "../Pages/Pages/index.js";
import PageCreate from "../Pages/Pages/create.js";
import LandingEditor from "../Pages/Pages/LandingEditor.js";
import SalesTeams from "../Pages/SalesTeams/index.js";
import SalesTeamDetails from "../Pages/SalesTeams/details.js";
import SalesTeamMembers from "../Pages/SalesTeams/members.js";

const authProtectedRoutes = [
  // Onboarding (sin layout)
  { path: "/onboarding", component: <OnboardingPage />, noLayout: true },
  
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },

  { path: "/dashboard/contact-list", component: <ContactList /> },
  { path: "/dashboard/bot-builder", component: <BotBuilder /> },
  { path: "/dashboard/bot-builder/:idBot", component: <EditBot /> },

  // Calender
  { path: "/calendar", component: <Calender /> },

  //Modules
  { path: "/contact-lists", component: <ContactLists /> },
  { path: "/contact-lists/:id", component: <ContactListDetails /> },
  { path: "/campaigns", component: <Campaigns /> },
  { path: "/campaigns/create", component: <CampaignCreate /> },
  { path: "/campaigns/:id", component: <CampaignDetails /> },
  { path: "/campaigns/:id/edit", component: <CampaignCreate /> },

  { path: "/landing-templates", component: <LandingTemplates /> },
  { path: "/landing-templates/:id", component: <LandingTemplates /> },
  { path: "/email-templates", component: <EmailTemplates /> },
  { path: "/email-templates/new/ai", component: <NewAITemplate /> },
  { path: "/email-templates/new/builder", component: <NewBuilder /> },
  { path: "/email-templates/new/template", component: <NewTemplate /> },
  { path: "/email-templates/:id", component: <DetailsEmailTemplate /> },
  { path: "/email-templates/:id/edit", component: <EditEmailTemplate /> },
  { path: "/leads", component: <Leads /> },
  { path: "/leads/new", component: <CreateLead /> },
  { path: "/leads/:id", component: <LeadsDetails /> },
  { path: "/email-validation", component: <EmailValidation /> },
  { path: "/email-providers", component: <EmailProviders /> },
  { path: "/calendar-providers", component: <CalendarProviders /> },
  { path: "/new-email-test", component: <EmailComponent /> },
  { path: "/corporate-identity", component: <CorporateIdentity /> },
  { path: "/whatsapp-templates", component: <WhatsAppTemplates /> },
  { path: "/whatsapp-providers", component: <WhatsAppProviders /> },
  { path: "/conversations", component: <Conversations /> },
  { path: "/automation/workflows", component: <Workflows /> },
  { path: "/automation/workflows/:id", component: <WorkflowBuilder /> },
  { path: "/automation/workflows/new", component: <WorkflowBuilder /> },
  { path: "/automation/executions", component: <Executions /> },
  { path: "/automation", component: <Automation /> },
  { path: "/events", component: <Events /> },
  { path: "/pages", component: <Pages /> },
  { path: "/pages/new", component: <PageCreate /> },
  { path: "/pages/:id/edit", component: <PageCreate /> },
  { path: "/pages/:id/visual-editor", component: <LandingEditor />, noLayout: true },
  { path: "/sales-teams", component: <SalesTeams /> },
  { path: "/sales-teams/members", component: <SalesTeamMembers /> },
  { path: "/sales-teams/:id", component: <SalesTeamDetails /> },


  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // E-mail
  { path: "/inbox", component: <Inbox /> },
  { path: "/read-email", component: <ReadEmail /> },
  { path: "/compose-email", component: <EmailCompose /> },

  // Utility Pages
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/pages-timeline", component: <TimeLine /> },
  { path: "/pages-faqs", component: <FAQs /> },
  { path: "/pages-pricing", component: <Pricing /> },

  // UiElements Pages
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-breadcrumb", component: <UiBreadcrumb /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-sessiontimeout", component: <UiSessionTimeout /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-progressbars", component: <UiProgressBars /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-tabs-accordions", component: <UiTabs /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-toasts", component: <UiToasts /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-popovers", component: <UiPopovers /> },
  { path: "/ui-rating", component: <UiRating /> },

  // Forms pages
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-validation", component: <FormValidations /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editor", component: <FormEditors /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-editors", component: <FormXeditable /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-mask", component: <FormMask /> },

  // Tables pages
  { path: "/tables-basic", component: <BasicTable /> },
  { path: "/tables-listjs", component: <ListJs /> },
  { path: "/table-datatables", component: <DataTable /> },

  // Charts Pages
  { path: "/chart-apexcharts", component: <ApexCharts /> },
  { path: "/chart-chartjscharts", component: <ChartJs /> },
  { path: "/chart-floatcharts", component: <FloatChart /> },
  { path: "/chart-jknobcharts", component: <JknobCharts /> },
  { path: "/chart-sparklinecharts", component: <Sparklinechart /> },

  // Icons Pages
  { path: "/icon-boxicon", component: <IconBoxicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icon-dripicons", component: <IconDripicons /> },

  // Maps Pages
  { path: "/maps-vector", component: <VectorMaps /> },
  { path: "/maps-google", component: <GoogleMap /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/registro", component: <Register /> },
  { path: "/password-recovery", component: <PasswordRecovery /> },
  { path: "/reset-password", component: <ResetPassword /> },

  // Authentication Inner Pages
  { path: "/auth-login", component: <Login1 /> },
  { path: "/auth-register", component: <Register1 /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },

  // Utility Pages
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
